module.exports = __webpack_public_path__ + "static/img/rank_36.78b91e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_36.png
// module id = tG2r
// module chunks = 1